import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/intel/Layout";
import { ModuleShell } from "@/components/intel/ModuleShell";
import { ThreatSimulationPanel } from "@/components/intel/ThreatSimulationPanel";

export const Route = createFileRoute("/threat-simulation")({
  head: () => ({ meta: [
    { title: "Threat Simulation · CARIO INTEL" },
    { name: "description", content: "Passive public-source cyber exposure assessment for companies and domains." },
    { property: "og:title", content: "Threat Simulation · CARIO INTEL" },
    { property: "og:description", content: "Prioritized defensive assessment of exposed services, credentials, technologies, attack surface, and public infrastructure." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: ThreatSimulationPage,
});

function ThreatSimulationPage() {
  return <AppLayout><ModuleShell eyebrow="Defensive Intelligence" title="Threat simulation" description="Evaluate a company’s publicly observable attack surface and turn the strongest evidence into prioritized defensive action."><ThreatSimulationPanel /></ModuleShell></AppLayout>;
}